module.exports = __webpack_public_path__ + "img/icon-sb-other-sectional-layouts_v1.fe36a50.svg";